var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"ppv2-min-w-[400px] ppv2-mb-5 ppv2-px-6 ppv2-py-2 ppv2-text-[#7d2dbd] ppv2-border ppv2-border-[#7d2dbd] ppv2-rounded-lg hover:ppv2-bg-[#7d2dbd] hover:ppv2-text-white ppv2-text-center",attrs:{"href":_vm.href}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }